import React from "react"
import ReactHtmlParser from "react-html-parser";

function ConvertStringToHtml(props){
    return(<>
    {ReactHtmlParser(props.msg)}</>)
}
export default ConvertStringToHtml